/*
  Nota das avaliações nos dados estruturados do produto.
  O BK Reviews mostra a nota na página (ex.: "5 (4 Avaliações)"), mas não a envia ao Google.
  Aqui lemos a mesma nota que o cliente vê e a acrescentamos ao JSON-LD do Product,
  para o Google poder exibir as estrelas nos resultados. Só roda em páginas de produto.
*/
(function () {
  'use strict';

  var done = false;
  var started = Date.now();

  function readRating() {
    var el = document.querySelector('.product__info-container .bk-reviews');
    if (!el) return null;
    var text = (el.textContent || '').replace(/\s+/g, ' ');
    var m = text.match(/(\d+(?:[.,]\d+)?)\s*\(\s*(\d+)\s*avalia/i);
    if (!m) return null;
    var value = parseFloat(m[1].replace(',', '.'));
    var count = parseInt(m[2], 10);
    if (!(value >= 1 && value <= 5) || !(count >= 1)) return null;
    return { value: value, count: count };
  }

  function apply(rating) {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      var data;
      try { data = JSON.parse(scripts[i].textContent); } catch (e) { continue; }
      var items = Object.prototype.toString.call(data) === '[object Array]' ? data : [data];
      for (var j = 0; j < items.length; j++) {
        if (items[j] && items[j]['@type'] === 'Product') {
          if (items[j].aggregateRating) return true;
          items[j].aggregateRating = {
            '@type': 'AggregateRating',
            ratingValue: String(rating.value),
            reviewCount: String(rating.count),
            bestRating: '5',
            worstRating: '1'
          };
          scripts[i].textContent = JSON.stringify(data);
          return true;
        }
      }
    }
    return false;
  }

  function check() {
    if (done) return;
    var rating = readRating();
    if (rating && apply(rating)) {
      done = true;
      if (observer) observer.disconnect();
    } else if (Date.now() - started > 20000 && observer) {
      observer.disconnect();
    }
  }

  var observer = null;
  function start() {
    check();
    if (done || !window.MutationObserver) return;
    var timer = null;
    observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(check, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
